<template>
  <div class="step step--school-state">
    <button-back @back="back"></button-back>
    <div class="text-center">
      <div align-h="center">
        <div md="8" sm="12">
          <div class="mb-4">
            <icon-map class="step__icon" />
            <h2>Where do you want to go to school?</h2>
          </div>
          <div class="step__multiselect step__multiselect--single">
            <multiselect ref="stateSelect" v-model="user.selected" :options="states" :multiple="false" placeholder="" @input="onChange">
              <template slot="singleLabel" slot-scope="{ option }">
                <span class="custom__tag">
                  <span class="custom__tag-label">Select a state</span>
                  <span>{{ option }}</span>
                </span>
              </template>
              <template slot="option" slot-scope="{ option }">
                <span>{{option}}</span>
              </template>
            </multiselect>
            <div class="multiselect__label">
              Select a state
            </div>
          </div>
          <!-- <div xl="6" lg="8" sm="12" class="select-container">
            <select ref="stateSelect" v-model="user.state" class="select" placeholder="Select a State">
              <option disabled value="">Select a state</option>
              <option v-for="state in states" v-bind:key="state.value" :value="state.abbreviation">{{ state.name }}</option>
            </select>
          </div> -->
          <div xl="6" lg="8" sm="12">
            <a href="#" class="btn btn-link" @click="submit">I'm not sure</a>
          </div>
        </div>
      </div>
      <div class="text-left no-gutters" align-h="center">
        <disclaimer />
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import ButtonBack from '../buttons/Back.vue'
import IconMap from '../animatedicons/IconMap.vue'
import Disclaimer from '../Disclaimer.vue'
import states from './../../data/states.json';

export default {
  name: 'SchoolStateStep',
  props: {
    user: Object
  },
  data: function () {
    return {
      states: states.map(({ name }) => name),
    }
  },
  methods: {
    back: function () {
      this.$emit('back');
    },
    submit: function(e){
      e.preventDefault();
      this.user.state = null
      this.$emit('completed');
    },
    onChange: function(){
      setTimeout(() => {
        const container = this.$refs.stateSelect.$el.parentElement;

        if ( typeof this.$refs.stateSelect.value === 'string' ) {
          container.classList.add('limit');
          this.user.state = this.$refs.stateSelect.value
        } else {
          container.classList.remove('limit');
        }
      }, 0);
    },
  },
  mounted: function () {
    this.onChange();
  },
  watch: {
    'user.state': function () {
      if (this.user.state) {
        this.$emit('completed');
      }
    },
  },
  components: {
    Multiselect,
    ButtonBack,
    IconMap,
    Disclaimer,
  }
}
</script>

<style scoped>
</style>
